import { Immutable } from "immer";
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import type { MattressFoundationAdvert as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import bannerStyles from "../../styles/composable/banner.module.scss";

type IProps = Immutable<{
    value: Value | null;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/adverts/mattress_foundation_advert.html`` (#33285). The block
 * is a value-less StaticBlock: the serialized value is an empty object (or
 * null on the standalone template path) and is ignored.
 */
export const MattressFoundationAdvert = (_props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <section
            className={concatClassNames([
                bannerStyles.banner,
                bannerStyles.bannerShade,
            ])}
        >
            <img
                className={concatClassNames([
                    bannerStyles.bannerBackground,
                    "img-responsive",
                ])}
                src={`${staticURL}img/advert/banner-foundation.png`}
                alt="Sealy Foundation"
                loading="lazy"
                decoding="async"
            />
            <div
                className={concatClassNames([
                    bannerStyles.bannerContent,
                    bannerStyles.bannerContentMdlext,
                ])}
            >
                <h3 className={bannerStyles.bannerTitle}>
                    {t`Don't need an adjustable base?`}
                </h3>
                <p className={bannerStyles.bannerCopy}>
                    {t`It's still important to support your Sealy mattress with a foundation to help prevent bowing or sagging. Our StableSupport™ Foundation maximizes the comfort and durability of Sealy mattresses. Available in 5-inch and 9-inch heights.`}
                </p>
            </div>
        </section>
    );
};
